import './CustomPage.less';

export const prefix = 'bm-c-custom-page';

export { default } from './CustomPage';
